import jwt from 'jsonwebtoken'
import { hasPermission } from '@/javascripts/auth'

var passport = {
  // 获取localStorage中的token
  getInfo: () => {
    // console.log(`获取身份 -> ${localStorage.passport}`);
    if (localStorage.passport === 'undefined' || localStorage.passport === '' || localStorage.passport == null) {
      return false
    } else {
      return localStorage.passport
    }
  },
  // 设置token到localStorage
  setInfo: (info) => {
    // console.log(`设置身份 -> ${info}`);
    localStorage.passport = info
  },
  // 获取token中的权限
  permission: () => {
    const token = localStorage.passport && localStorage.passport.trim()
    const userInfo = jwt.decode(token)
    // console.log('user', userInfo, token)

    if (userInfo && userInfo.roles === 1) {
      return true
    }
    return false
  },
  getUserInfo: () => {
    const token = localStorage.passport && localStorage.passport.trim()
    if (typeof token !== 'string') return null

    const userInfo = jwt.decode(token)
    if (userInfo) {
      return userInfo
    } else {
      return null
    }
  },
  checkAuth: (targetRoles) => {
    const info = passport.getUserInfo()
    if (!info || !info.roles) return false
    if (info.roles.includes(1)) return true
    const hasAuth = hasPermission(info.roles, targetRoles)
    return hasAuth
  },
  // 设置请求头headers
  headers: () => {
    return { Authorization: 'Bearer ' + passport.getInfo() }
  }
}

export default passport
